<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/QUSGLO/tc-custom/9780062418562.jpg?1713995747935" alt="This image is the cover for the book Fall of Poppies"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Fall of Poppies
      </h1>
      <p class="bookDescription body article font2">
        <p>Top voices in historical fiction deliver an unforgettable collection of short stories set in the aftermath of World War I—featuring bestselling authors such as Hazel Gaynor, Jennifer Robson, Beatriz Williams, and Lauren Willig and edited by Heather Webb.</p><p><i>On the eleventh hour of the eleventh day of the eleventh month...</i></p><p>November 11, 1918. After four long, dark years of fighting, the Great War ends at last, and the world is forever changed. For soldiers, loved ones, and survivors the years ahead stretch with new promise, even as their hearts are marked by all those who have been lost.</p><p>As families come back together, lovers reunite, and strangers take solace in each other, everyone has a story to tell.</p><p>In this moving anthology, nine authors share stories of love, strength, and renewal as hope takes root in a fall of poppies.</p><p>Featuring:</p><p>Jessica Brockmole</p><p>Hazel Gaynor</p><p>Evangeline Holland</p><p>Marci Jefferson</p><p>Kate Kerrigan</p><p>Jennifer Robson</p><p>Beatriz Williams</p><p>Lauren Willig</p><p>Heather Webb </p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Heather Webb, Hazel Gaynor, Beatriz Williams, Jennifer Robson
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      HarperCollins
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?46cb4074